const GET_NAV_LIST = "store/navigation";
const GET_HOME_LIST = "getHomeList";
const GET_LIST_BY_NAV_ID = "catalog/product/list";
const GET_LIST_LAYER = "catalog/product/list/layer";
const SEARCH = "catalog/product/search";
const SEARCH_LAYER = "catalog/product/search/layer";
const SUGGESTION = "catalog/product/suggestion";
const RECOMMEND = "catalog/product/recommend";
const VIEWED = "catalog/product/history";
const GET_DETAIL = "catalog/product/detail";
const GET_SEARCH_HOT = "catalog/product/search/hot";
const GET_COMMENTS = "commentList";
const ADD_COMMENT = "addComment";
const NOTIFY = "product/notify";
const GET_CART_INFO = "getCartInfo";
const ADD_TO_CART = "addToCart";
const DEL_CART = "delCart";
const UPDATE_OPTION = "updateOption";
const REGISTER = "register";
const LOGIN = "login";
const LOGOUT = "logout";
const FORGOT = "forgot";
const CAPTCHA = "captcha";
const SEND_SMS = "sendSMS";
const GET_PROFILE = "getProfile";
const UPDATE_PROFILE = "updateProfile";
const CHANGE_PASSWORD = "changePassword";
const CODE_2_INFO = "code2info";
const BIND_USER_INFO = "tpBind";
const CONFIRM = "confirm";
const CREATE_ORDER = "createOrder";
const ORDER_PAY = "orderPay";
const QUERY_ORDER_PAY_STATUS = "";
const ORDER_STATUS = "orderStatus";
const ORDER_LIST = "orderList";
const ORDER_DETAIL = "orderDetail";
const CANCEL_ORDER = "cancelOrder";
const SAVE_REFUND_INFO = "saveRefundInfo";
const ADDRESS_LIST = "addressList";
const SAVE_ADDRESS = "saveAddress";
const DEL_ADDRESS = "delAddress";
const SET_DEF_ADDRESS = "setDefAddress";
const GET_STORES = "getStoreList";
const GET_OSS_STORES = "shop/shopManagementList";
const GET_OSS_TAGS = "GET_OSS_TAGS";
const CHECK_NEW_CUSTOMER_STATUS = "settle/checkNewCustomerStatus";
const CMS_PAGE = "cms";
const CMS_PAGE_V2 = "getCms";
const GETPOINTSHISTORY = "getPointsHistory";
//快捷注册
const QUICK_REGISTER_SMS_CODE = "getSmsCode";
const QUICK_REGISTER_BY_MOBILE = "registerByMobileForOw";
// 获取省市区
const GET_CITIES = "address/getCities";
// 获取优惠券列表
const GET_COUPON_LIST = "account/getCouponList";
// 获取优惠券详情
const GET_COUPON_DETAIL = "account/getCouponDetail";
//OWHS-9910 - 【OT】网站和小程序前端请求header传上级页面URL
const PUSH_HISTORY = "pushHistory";
//OWHS-10117 - 【OT】管小下单时最高抵扣积分由20% 改为30%
//获取oss json全局配置
const GET_OSS_COMMON_CONFIG = "GET_OSS_COMMON_CONFIG";
const GET_OSS_MP_CONFIG = "GET_OSS_MP_CONFIG";
const GET_SETTLE_COUPONLIST = "settle/getCouponList";
const CHECKOUT_CONFIRM_DISCOUNT = "settle/confirmDiscount";
const GET_AFTER_SALES_TIPS_JSON = 'GET_AFTER_SALES_TIPS_JSON';
const AFTER_SALES_OPTIONS = 'rma/params';
// 商品限购信息接口
const GET_PRODUCT_LIMIT = "catalog/product/limitation";

// 订单
const CONFIRM_RECEIPT = 'order/confirmReceipt'
// 售后订单
const GET_AFTER_SALES_ORDER_LIST = "rma/list";
const APPLY_RMA_SAVE= "rma/rmaSave";
const GET_LOGISTICS_INFO = "express/logisticsInfo";
const GET_RMA_DETAIL = "rma/detail";

// 结算分期信息
const CHECK_ORDER_INSTALLMENT = "settle/checkOrderInstallment";
const CHECK_CART_INSTALLMENT = "settle/checkCartInstallment";

// GA 事件上报
const GET_PUSH_RECORD = "order/getPushRecord";
const SAVE_PUSH_RECORD = "order/savePushRecord";

// Cookie相关
// Cookie 隐私政策相关
export const SET_COOKIE_ACCEPT = "SET_COOKIE_ACCEPT";
export const SET_PRIVACY_ACCEPT = "SET_PRIVACY_ACCEPT";
export const SHOW_COOKIE_DIALOG = "SHOW_COOKIE_DIALOG";

// 隐私政策
export const SAVE_CLICK_ACTION = "saveClickAction";


export default {
  GET_NAV_LIST,
  GET_HOME_LIST,
  GET_LIST_BY_NAV_ID,
  GET_LIST_LAYER,
  SEARCH,
  SEARCH_LAYER,
  SUGGESTION,
  RECOMMEND,
  VIEWED,
  GET_DETAIL,
  GET_SEARCH_HOT,
  GET_COMMENTS,
  ADD_COMMENT,
  NOTIFY,
  GET_CART_INFO,
  ADD_TO_CART,
  DEL_CART,
  UPDATE_OPTION,
  REGISTER,
  LOGIN,
  LOGOUT,
  FORGOT,
  CAPTCHA,
  SEND_SMS,
  GET_PROFILE,
  UPDATE_PROFILE,
  CHANGE_PASSWORD,
  CODE_2_INFO,
  BIND_USER_INFO,
  CONFIRM,
  CREATE_ORDER,
  ORDER_PAY,
  QUERY_ORDER_PAY_STATUS,
  ORDER_LIST,
  ORDER_DETAIL,
  CANCEL_ORDER,
  SAVE_REFUND_INFO,
  ADDRESS_LIST,
  SAVE_ADDRESS,
  DEL_ADDRESS,
  SET_DEF_ADDRESS,
  GET_STORES,
  CMS_PAGE,
  CMS_PAGE_V2,
  GETPOINTSHISTORY,
  QUICK_REGISTER_SMS_CODE,
  QUICK_REGISTER_BY_MOBILE,
  GET_CITIES,
  PUSH_HISTORY,
  GET_PRODUCT_LIMIT,
  GET_OSS_STORES,
  GET_OSS_TAGS,
  CHECK_NEW_CUSTOMER_STATUS,
  GET_COUPON_LIST,
  GET_COUPON_DETAIL,
  GET_OSS_COMMON_CONFIG,
  GET_OSS_MP_CONFIG,
  GET_SETTLE_COUPONLIST,
  CHECKOUT_CONFIRM_DISCOUNT,
  ORDER_STATUS,
  SET_COOKIE_ACCEPT,
  CHECK_ORDER_INSTALLMENT,
  CHECK_CART_INSTALLMENT,
  GET_PUSH_RECORD,
  SAVE_PUSH_RECORD,
  GET_AFTER_SALES_TIPS_JSON,
  AFTER_SALES_OPTIONS,
  GET_AFTER_SALES_ORDER_LIST,
  CONFIRM_RECEIPT,
  APPLY_RMA_SAVE,
  GET_LOGISTICS_INFO,
  GET_RMA_DETAIL,
  SET_PRIVACY_ACCEPT,
  SHOW_COOKIE_DIALOG,
  SAVE_CLICK_ACTION
};
